export default __webpack_public_path__ + "static/media/sneakers-send.4305e5fb.svg";